// extracted by mini-css-extract-plugin
module.exports = {"container":"info_entry_container__33CRB","label":"info_entry_label__zUGQ4","content":"info_entry_content__15954"};